export default {
  outfits: []
};
